import styled from "styled-components";

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 200px;
  color: ${({ theme }) => theme.colors?.text?.body ?? "#6b7280"};
  font-size: 14px;
  font-weight: 500;
`;

/**
 * Full-width loading state for page or list content.
 */
export function PageLoading({ message = "Loading..." }) {
  return <Wrapper>{message}</Wrapper>;
}

const Skeleton = styled.div`
  height: ${({ $height }) => $height ?? "20px"};
  border-radius: 8px;
  background: linear-gradient(
    90deg,
    #f3f4f6 25%,
    #e5e7eb 50%,
    #f3f4f6 75%
  );
  background-size: 200% 100%;
  animation: shimmer 1.2s ease-in-out infinite;

  @keyframes shimmer {
    0% { background-position: 200% 0; }
    100% { background-position: -200% 0; }
  }
`;

/**
 * Inline skeleton placeholder (e.g. for stat cards or table rows).
 */
export function SkeletonLine({ height }) {
  return <Skeleton $height={height} />;
}
